/**
 * util functions to maintain middle state (null) for Boolean and Number
 */
const isNumeric = (val?: string | number | null) =>
  Boolean(!isNaN(Number(val)) && isFinite(Number(val)) && val !== null && val !== undefined && val !== '');

const typeCheckUtils = {
  Boolean: (val?: boolean | null) => (val === null || val === undefined ? null : Boolean(val)),
  Number: (val?: string | number | null) => (isNumeric(val) ? Number(val) : null),
  isNumeric,
};

export default typeCheckUtils;
